/**
 * Normalize legacy snake_case keys in a `data_point` JSON object to the
 * canonical camelCase keys used across the app.
 */
export function normalizeDataPointKeys(dp: Record<string, any> | null | undefined) {
  if (!dp || typeof dp !== "object") return dp;

  const out: Record<string, any> = { ...dp };

  const map: Record<string, string> = {
    is_correct: "isCorrect",
    prompt_level: "promptLevel",
    step_id: "stepId",
    start_time: "startTime",
    end_time: "endTime",
    cue_time: "cueTime",
    response_time: "responseTime",
    timestamp: "timestamp",
    count: "count",
    rating: "rating",
  };

  for (const [snake, camel] of Object.entries(map)) {
    if (
      Object.prototype.hasOwnProperty.call(out, snake) &&
      !Object.prototype.hasOwnProperty.call(out, camel)
    ) {
      out[camel] = out[snake];
      delete out[snake];
    }
  }

  return out;
}

export function normalizeDataPointsArray(arr: Array<Record<string, any>> | null | undefined) {
  if (!Array.isArray(arr)) return arr ?? [];
  return arr.map((r) => normalizeDataPointKeys(r) as Record<string, any>);
}

export default normalizeDataPointKeys;
